import { getWindowConfig, } from '~/utils/env';
import { PayBill, } from './pay-bill';

PayBill('#app', (s) => getWindowConfig(s));
